var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-popover',{ref:_vm.id,attrs:{"id":_vm.id,"placement":_vm.placement,"trigger":"manual","custom-class":_vm.$attrs['class-list'],"target":_vm.target,"container":_vm.container}},[_vm._t("title"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }